import axios from './helpers/axiosConfig';
import { __ } from './helpers/i18n';
import consentManager from './helpers/consentManager';
import { getStorage, setStorage, delStorage } from './helpers/storage';
import { shouldLoadScripts, registerGlobal, changeImportFile } from './helpers/others';
import { initSliders } from './functions/sliders';
import { customSelect, customNumber } from './functions/custom-forms';
import { toggle } from './functions/toggle';
import { tabs } from './functions/tabs';
import { addToFavorites } from './functions/favorites';
import { survey } from './widgets/cms/survey';
import { login } from './widgets/cms/login';
import { compare } from './views/store/comparison';
import { faqRatings, faqAsist } from './views/cms/faq';
import { addressType } from './views/cms/users';
import { addressValidation } from './views/cms/users';
import { modal, revealModal } from './functions/modal';
import { initGlightbox } from './functions/glightbox';
import { anotherOption } from './functions/form';
import { rangeTrigger } from './functions/ranges';
import { initSliderVideos } from './functions/video';
import { initAccordions } from './functions/accordion';
import { animateScroll } from './functions/animate-scroll';
import { initDefaultFWBlocks } from './functions/full-width';
import { replaceSingleLetterWords } from './functions/replace-words';
import { equalizeHeights } from './functions/equalize-heights';
import { lazyVideos } from './functions/lazy-videos';
import { initCtaBanner } from './widgets/cms/cta-banner';
import { initWcag } from './functions/wcag';
import { cookiesModal } from './functions/cookies';
import { initCollapseContent } from './functions/collapse-content';
import { initMainMenu } from './widgets/cms/menu';
import { iframeHeight } from './functions/iframe-height';
import { initLinks } from './functions/links';
registerGlobal({ getStorage, setStorage, delStorage, __, shouldLoadScripts, axios, consentManager, modal });
document.addEventListener('DOMContentLoaded', _ => {
    replaceSingleLetterWords();
    initSliders();
    initSliderVideos();
    initAccordions();
    customSelect();
    customNumber();
    initGlightbox();
    initMainMenu();
    toggle('open', '.toggle-title');
    toggle('open', '.mobile-filters-toggle', '.filters-side-box');
    toggle('open', '.bottom-menu-trigger', '', '.bottom-bar');
    toggle('open', '.global-menu-close', '.global-menu .global-menu-trigger');
    toggle('open', '.bottom-bar .bottom-menu .has-child', '.toggle-wrapper', '', true);
    toggle('open', '.footer-top .menu-expanded .footer-menu .has-child', '.toggle-wrapper', '', true);
    toggle('open', '.faq-item-trigger');
    tabs();
    addToFavorites();
    survey();
    login();
    compare();
    revealModal();
    faqRatings();
    faqAsist();
    anotherOption();
    addressType();
    addressValidation();
    rangeTrigger();
    consentManager.updateGtagConsent();
    changeImportFile();
    animateScroll();
    initDefaultFWBlocks();
    tabs();
    lazyVideos();
    initCtaBanner();
    initWcag();
    cookiesModal();
    initCollapseContent();
    iframeHeight();
    if (!document.body.classList.contains('layout-empty')) {
        initLinks();
    }
    window.addEventListener('load', equalizeHeights);
    window.addEventListener('resize', equalizeHeights);
});
